import { useCallback } from 'react';

import { EJsonQueryPriceType } from '../../../../../../../../repositories/common/json_query';

export function useHandlePriceTypeChange(setPriceType: (priceType: EJsonQueryPriceType | undefined) => void) {
  return useCallback<(priceType: EJsonQueryPriceType) => void>(
    priceType => {
      const newPriceType = priceType === EJsonQueryPriceType.All ? undefined : priceType;

      setPriceType(newPriceType);
    },
    [setPriceType],
  );
}
